import { SectionOne } from "../components/feature/Order";

export default function OrderPage()
{
    return(
        <section className="">
            <SectionOne/>
        </section>
    );
}